export let simpleData = [{
    day: '周一',
    lateCount: 10,
    forgetDailyCount: 12
}, {
    day: '周二',
    lateCount: 8,
    forgetDailyCount: 4
}, {
    day: '周三',
    lateCount: 5,
    forgetDailyCount: 7
}, {
    day: '周四',
    lateCount: 9,
    forgetDailyCount: 3
}, {
    day: '周五',
    lateCount: 11,
    forgetDailyCount: 2
}]